import Brain from "./brain";
import VectorTools from "./vectorTools";

export default class BrainSimpleText extends Brain {

	constructor(args) {
		super(args);
	}

	init(entity) {
		super.init(entity);
	}

	updateText(string) {
		let vt = VectorTools.get();
		vt.updateTextPaths(string, this.entity);
	}

}